import { Link, useLocation } from "react-router-dom";
import { NAV_LINKS, SOCIALS, ARTIST_NAME, SITE_LOCATION } from "@/data/site";
import { Wordmark } from "./Wordmark";
import { HeartIcon } from "./HeartIcon";

export const Footer = () => {
  const location = useLocation();
  return (
    <footer data-testid="site-footer" className="relative border-t border-white/10 bg-black/85 py-12 backdrop-blur-md">
      <div className="mx-auto flex max-w-7xl flex-col items-center gap-7 px-6 lg:px-8">
        <Wordmark size="lg" />

        <nav className="flex flex-wrap items-center justify-center gap-x-7 gap-y-3">
          {NAV_LINKS.map((l) => (
            <Link
              key={l.label}
              to={l.to}
              className={`font-accent text-[0.65rem] uppercase tracking-[0.2em] transition-colors ${
                location.pathname === l.to
                  ? "text-[var(--sm-gold-light)] hover:text-white"
                  : "text-white/55 hover:text-[var(--sm-gold-light)]"
              }`}
            >
              {l.label}
            </Link>
          ))}
          {SOCIALS.map((s) => (
            <a
              key={s.label}
              href={s.href}
              target="_blank"
              rel="noopener noreferrer"
              data-testid={`footer-social-${s.label.toLowerCase()}`}
              className="font-accent text-[0.65rem] uppercase tracking-[0.2em] text-white/55 transition-colors hover:text-[var(--sm-gold-light)]"
            >
              {s.label}
            </a>
          ))}
        </nav>

        {/* Sierra's moon-phase glyph isn't carried over — her heart-and-wing
            mark takes that quiet decorative slot instead. */}
        <HeartIcon size={16} className="opacity-70" />

        <p className="font-body text-xs font-light text-white/35">
          © {new Date().getFullYear()} {ARTIST_NAME} · {SITE_LOCATION}. All rights reserved.
        </p>
      </div>
    </footer>
  );
};
